<template>  
  <div id="app">
    <div class="page-freeUser py-3">
      <div class="row">
        <div class="col-12 pt-1" align="left">
          <router-link to="/">  
            <b-button variant="light">
              &lt;&lt;&lt;--- Volver atras
            </b-button>
          </router-link>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-12 col-xl-12">           
            <div class="cont-freeUser-text d-flex flex-column justify-content-around mt-5 mt-md-5">
              <div class="cont-title">
                <p class="title-1 mb-0">¡Bienvenido a tu Virtual Partner Foros!</p>
                <p class="title-1 mb-0"><b>{{this.name}}</b> - {{this.position}}</p>
                <p
                  class="desc mt-5 pr-0 pr-md-5"
                >Selecciona un foro para ingresar</p>
              </div>
              <!--div v-if="loading" id="loader"></div-->
              <div>
              <!-- .cont-title -->                
                <b-table
                  id="my-table"
                  :items="filas" 
                  :fields="campos"
                  :current-page="currentPage"
                  :per-page="perPage"
                  hover                    
                  @row-clicked="selected">                  
                  
                </b-table>
                <b-pagination
                  v-model="currentPage"
                  :total-rows="rows"
                  :per-page="perPage"
                  aria-controls="my-table"
                  align="center"
                ></b-pagination>
              </div>
              <div class="footer1">
                <p class="p1">Powered</p>
                <img align="right" src="@/assets/images/icons/logo-dp.svg" alt="logo dp" />
              </div>
              <div>
                <b-modal 
                  ref="my-modal" 
                  hide-footer
                  centered
                  title="Atención al mensaje:"
                  no-close-on-backdrop
                  @hidden="hideModal">
                  <div class="d-block text-center">
                    <h3>{{this.msjModal}}</h3>
                  </div>
                  <b-button class="mt-3" variant="outline-danger"
                    block 
                    @click="hideModal">
                      Cerrar
                  </b-button>
                </b-modal>
              </div>
            </div>            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import serverConfig from "./../../services/config";
export default {
  name: "Informer",
  components: {},
  data() {
    return {
      serverPath: serverConfig.permisosURL,
      error: {
        flag: false,
        class: "", //is-valid
        message: "",
      },
      success: {
        flag: false,
        class: "", //is-invalid
        message: "",
      },
      name: "",
      position: "",
      participant: "",
      img1: 'circle-clock.svg',
      img2: 'circle-clock.svg',
      msjModal: '',
      flagPath: 0,
      campos: [ 
        { key: 'idForum', label:'ID del foro', class: 'text-left'  }, 
        { key: 'fecha', label: 'Fecha', class: 'text-left'   },         
        { key: 'estado', label: 'Estado del foro', class: 'text-left'  },
        { key: 'idDP', label: 'ID del DP', class: 'text-left'  },
        { key: 'estadoDP', label: 'Estado del DP', class: 'text-left'  }
      ],
      filas: [],
      perPage: 5,
      currentPage: 1,
    };
  },
  beforeMount(){
    this.actGetInformerInfo(this.$route.params.email).then(() =>{
      if(this.informerInfo.data){                    
        for(let i=this.informerInfo.data.length-1; i >= 0; i--){    
          if(this.informerInfo.data[i][0].participant.forum.status == 'open' && this.informerInfo.data[i][0].participant.status == 1){
            this.filas.push({
              "idForum": this.informerInfo.data[i][0].participant.forum.id,
              "fecha": this.informerInfo.data[i][0].participant.forum.petition_right.created_at.substring(0,10),            
              "estado": this.informerInfo.data[i][0].participant.forum.status,
              "idDP": this.informerInfo.data[i][0].participant.forum.petition_right.id,
              "estadoDP": this.informerInfo.data[i][0].participant.forum.petition_right.status
            });
          }
        }
        this.name = this.informerInfo.data[0][0].participant.name;
        this.position = this.informerInfo.data[0][0].participant.position;
      }
    });
  },
  computed: {    
    ...mapState("modRightPetition", [
      "informerInfo",
    ]),

    rows(){
      return this.filas.length
    }
  },
  methods: {
    ...mapActions("modRightPetition", [
      "actGetInformerInfo",
    ]),
    selected(record) {
      //alert(JSON.stringify(record))
      //alert(record.idSol)      
      this.$router.push({ path: '/forum/'+record.idDP+'/'+record.idForum+'/'+this.$route.params.email });      
    },
    showModal(msj,flag) {
        this.msjModal = msj;
        this.flagPath = flag;
        this.$refs['my-modal'].show()
      },
    hideModal() {
        this.$refs['my-modal'].hide()
        if(this.flagPath == 1){
          this.$router.push({ path: '/solicitudes' });
        }
     },
  },  
};
</script>

<style lang="scss">
  .cont-freeUser-text {
    .cont-title {
      color: #1c3a4e;
      .title-1 {
        font-size: 32px;
      }
      .title-2 {
        font-weight: bold;
        font-size: 34px;
        line-height: 36px;

        @media (min-width: 768px) {
          font-size: 80px;
          line-height: 80px;
        }
      }
    }
    .form-freeUser {
      .form-group {
        label {
          position: absolute;
          color: #454545;
          font-size: 12px;
          background-color: #ffffff;
          padding: 4px;
          top: -16px;
          left: 10px;
        }
        input[type="text"] {
          height: 36px;
          border: 1px solid #454545;
          border-radius: 4px;
          padding: 0 10px;
        }
      }
      button {
        background: #269887;
        color: #ffffff;
        border-radius: 50px;
        height: 36px;
        font-size: 16px;

        &:hover {
          background: darken(#269887, 5);
        }
      }
    }
    .footer1 {
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      background-color: #1C3A4E;
      color: white;
      text-align: right;
    }
  .p1{
    font-family: "Poppins";
    color: #FFFFFF;
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 15px;
    //text-align: right;
  }
  .button1 {
    background: #1C3A4E;
    color: #ffffff;
    border-radius: 50px;
    height: 32px;
    width: 70;    
    font-size: 16px;
    text-align: left !important;   
    padding-left: 5%;
    padding-right: 5%;
    &:hover {
      background: darken(#cddce6, 5);
    }
  }
  .tabla1{  
    border-radius: 5px;
    border: 3px solid #1C3A4E;
    border-color: #1C3A4E;  
    -moz-border-radius: 6px;
    border-collapse: separate;
    border-spacing: 0px;
    width: 530px
  }
  .img1 {
    width: 18px;
    height: 18px;    
    left: 100%;
    top: 100%;     
    float: center;    
  }
  .centerImg1 {
    width: 16px;
    height: 16px;    
    top: 100%;     
    float: right;    
  }
  /* Center the loader */
  #loader {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 1;
    width: 150px;
    height: 150px;
    margin: 85px 0 0 -75px;
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }

  @-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  /* Add animation to "page content" */
  .animate-bottom {
    position: relative;
    -webkit-animation-name: animatebottom;
    -webkit-animation-duration: 1s;
    animation-name: animatebottom;
    animation-duration: 1s
  }

  @-webkit-keyframes animatebottom {
    from { bottom:-100px; opacity:0 } 
    to { bottom:0px; opacity:1 }
  }

  @keyframes animatebottom { 
    from{ bottom:-100px; opacity:0 } 
    to{ bottom:0; opacity:1 }
  }

  #myDiv {
    display: none;
    text-align: center;
  }
} 
</style>